import script from "./PieChartComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PieChartComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PieChartComponent.vue?vue&type=style&index=0&id=7687fdea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7687fdea"]])

export default __exports__